import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import _ from 'lodash'

import config from '@config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import PaymentInformations from '../../PaymentInformations'

import { LOCALE_PREFIX } from './constants'

@hocBlock(config.modules.report.key, { levelReload: true })
@injectIntl
export default class PaymentIndex extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        transformedData: PropTypes.object,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true
        if (!_.isEqual(this.props.transformedData, nextProps.transformedData)) return true

        return false
    }

    render() {
        const {
            id,
            module,
            data,
            customData,
            block,
            level,
            intl: { formatMessage },
            transformedData,
        } = this.props

        return (
            <div className={'block-payment-index'}>
                <PaymentInformations
                    id={id}
                    module={module}
                    block={block}
                    customData={customData}
                    level={level}
                    data={transformedData?.summary?.summary}
                    legend={transformedData?.summary?.legend}
                    graphData={transformedData?.chart?.data || []}
                    breakdown={transformedData?.breakdown}
                    originalData={data}
                    translates={{
                        firm: formatMessage({ id: `${LOCALE_PREFIX}.firm` }),
                        sector: formatMessage({ id: `${LOCALE_PREFIX}.sector` }),
                        numberOfSuppliers: formatMessage({ id: `${LOCALE_PREFIX}.numberOfSuppliers` }),
                        numberOfInvoices: formatMessage({ id: `${LOCALE_PREFIX}.numberOfInvoices` }),
                        totalInvoiceAmount: formatMessage({ id: `${LOCALE_PREFIX}.totalInvoiceAmount` }),
                        paymentDue: formatMessage({ id: `${LOCALE_PREFIX}.paymentDue` }),
                        paymentDueAverage: formatMessage({ id: `${LOCALE_PREFIX}.paymentDueAverage` }),
                        paymentDueModus: formatMessage({ id: `${LOCALE_PREFIX}.paymentDueModus` }),
                        paymentDueMax: formatMessage({ id: `${LOCALE_PREFIX}.paymentDueMax` }),
                        riskIndicatorMessage: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.riskIndicatorMessage`}
                                values={{
                                    strong: (chunks) => <strong>{chunks}</strong>,
                                    br: <br />,
                                }}
                            />
                        ),
                        twelveMonthsTitle: formatMessage({ id: `${LOCALE_PREFIX}.twelveMonthsTitle` }),
                        threeMonthsTitle: formatMessage({ id: `${LOCALE_PREFIX}.threeMonthsTitle` }),
                        day: formatMessage({ id: `${LOCALE_PREFIX}.day` }),
                        days: formatMessage({ id: `${LOCALE_PREFIX}.days` }),
                        daysTwo: formatMessage({ id: `${LOCALE_PREFIX}.daysTwo` }),
                        terminologyToggleText: formatMessage({ id: `${LOCALE_PREFIX}.terminologyToggleText` }),
                        dueDaysFor12monthsText: (
                            <FormattedMessage id={`${LOCALE_PREFIX}.dueDaysFor12monthsText`} values={{ br: <br /> }} />
                        ),
                        dueDaysFor3monthsText: (
                            <FormattedMessage id={`${LOCALE_PREFIX}.dueDaysFor3monthsText`} values={{ br: <br /> }} />
                        ),
                        interval: <FormattedMessage id={`${LOCALE_PREFIX}.interval`} />,
                        description: <FormattedMessage id={`${LOCALE_PREFIX}.description`} />,
                        riskIndicatorInfoTextYear: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.riskIndicatorInfoTextYear`}
                                values={{
                                    strong: (chunks) => <strong>{chunks}</strong>,
                                    br: <br />,
                                    acz: (chunks) => (
                                        <a
                                            href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#7fcdee', textDecoration: 'underline' }}
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                    ask: (chunks) => (
                                        <a
                                            href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#7fcdee', textDecoration: 'underline' }}
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        riskIndicatorInfoTextQuarter: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.riskIndicatorInfoTextQuarter`}
                                values={{
                                    strong: (chunks) => <strong>{chunks}</strong>,
                                    br: <br />,
                                    acz: (chunks) => (
                                        <a
                                            href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#7fcdee', textDecoration: 'underline' }}
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                    ask: (chunks) => (
                                        <a
                                            href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#7fcdee', textDecoration: 'underline' }}
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        noData: <FormattedMessage id={`${LOCALE_PREFIX}.noData`} />,
                    }}
                />
            </div>
        )
    }
}
